(function($) {
  
  $(document).ready(function() {
    
  });
  
})(jQuery);

function initGoToTop(){
  var $ = jQuery;
  $('.m-gototop').on('click',function(){
    $('html, body').animate({
        scrollTop: 0
    }, 300)
  })
}